import { selectCategoryList } from '../api/x_category'
import { setCookie, getCookie } from '../utils/cookie'

const SET_CATEGORY = 'category/SET_CATEGORY'
const SET_SELECTED_CATEGORY = 'category/SET_SELECTED_CATEGORY'

/* 액션 생성함수 만들기 */
export const setCategory = (categoryList) => ({
  type: SET_CATEGORY,
  categoryList,
})

export const selectCategory = () => async (dispatch) => {
  try {
    const response = await selectCategoryList({ useYn: 'Y' })
    const data = response.data.data
    debugger
    if (data && !getCookie('selectedCategory')) {
      setCookie('selectedCategory', data[0]?.caSeq)
    }
    dispatch(setCategory(data))
  } catch (error) {
    // Handle error
    console.error('Error fetching users:', error)
  }
}

export const setSelectedCategory = (category) => ({
  type: SET_SELECTED_CATEGORY,
  selectedCategory: category,
})

/* 초기 상태 선언 */
const initialState = {
  categoryList: [],
  selectedCategory: {},
}

/* 리듀서 선언 */
export default function category(state = initialState, action) {
  switch (action.type) {
    case SET_CATEGORY:
      return {
        ...state,
        category: action.categoryList,
      }
    case SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.selectedCategory,
      }
    default:
      return state
  }
}
